import { Lock, ShieldCheck, Flame } from "lucide-react";
import { useLang } from "@/lib/i18n";

const FEATURES = [
  { icon: ShieldCheck, tKey: "features1" },
  { icon: Flame, tKey: "features2" },
  { icon: Lock, tKey: "features3" },
];

export default function FeaturesSection() {
  const { t } = useLang();
  return (
    <section
      className="max-w-7xl mx-auto px-6 md:px-10 py-16 border-t border-black/10 dark:border-white/10 grid grid-cols-1 md:grid-cols-3 gap-0"
      data-testid="features-section"
    >
      {FEATURES.map(({ icon: Icon, tKey }, i) => (
        <div
          key={tKey}
          className={`p-8 md:p-10 border border-black/10 dark:border-white/10 ${i === 0 ? "" : "md:border-l-0"} border-t-0 md:border-t`}
          data-testid={`feature-${tKey}`}
        >
          <Icon className="w-6 h-6 text-[#00ff66] mb-4" strokeWidth={1.75} />
          <h3 className="text-lg font-bold tracking-tight text-neutral-900 dark:text-white mb-2 uppercase">
            {t(`${tKey}Title`)}
          </h3>
          <p className="text-sm text-neutral-600 dark:text-neutral-400 leading-relaxed">{t(`${tKey}Body`)}</p>
        </div>
      ))}
    </section>
  );
}
